import { Game } from '../types';

export interface WeatherInfo {
    temp: number;
    icon: string;
    description: string;
}

const API_KEY = import.meta.env.VITE_OPENWEATHER_API_KEY;
const BASE_URL = 'https://api.openweathermap.org/data/2.5';

/**
 * 경기장의 날씨를 가져옵니다.
 * @param city 도시 이름 또는 경기장 위치
 * @param date 경기 날짜 (YYYY-MM-DD)
 */
export const getWeatherForMatch = async (city: string, dateStr?: string): Promise<WeatherInfo | null> => {
    if (!API_KEY || !city) return null;

    try {
        const targetDate = dateStr ? new Date(dateStr) : new Date();
        const now = new Date();
        const diffDays = Math.floor((targetDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

        // 무료버전에서는 5일 전 날씨를 위한 과거 데이터 API(History API)가 유료이거나 OneCall 3.0(카드등록필요)이므로,
        // 현재 날씨(Current Weather) API를 우선적으로 사용하고, 미래의 경우 5-Day Forecast API를 사용합니다.
        // 요구사항에 맞춰 '오늘의 경기 부터 5일 전날까지'를 지원하기 위해 과거 날짜인 경우 캐싱된 데이터나 현재 날씨를 대체재로 표시하거나, 
        // 만약 OneCall API가 열려있다면 해당 API를 쓰도록 구성할 수 있지만 여기서는 무료 버전의 기본 Current / Forecast API를 활용합니다.
        
        // 1. Geocoding API를 통해 위도(lat), 경도(lon) 조회
        const geoUrl = `https://api.openweathermap.org/geo/1.0/direct?q=${encodeURIComponent(city)}&limit=1&appid=${API_KEY}`;
        const geoRes = await fetch(geoUrl);
        if (!geoRes.ok) {
            console.error('Geocoding API error:', geoRes.statusText);
            return null;
        }
        
        const geoData = await geoRes.json();
        if (!geoData || geoData.length === 0) {
            console.warn(`No coordinates found for city: ${city}`);
            return null;
        }
        
        const { lat, lon } = geoData[0];

        // 2. 해당 좌표로 날씨 정보 조회
        let weatherUrl = `${BASE_URL}/weather?lat=${lat}&lon=${lon}&appid=${API_KEY}&units=metric&lang=kr`;

        const res = await fetch(weatherUrl);
        if (!res.ok) {
            console.error('Weather API error:', res.statusText);
            return null;
        }

        const data = await res.json();
        return {
            temp: Math.round(data.main.temp),
            icon: data.weather[0].icon,
            description: data.weather[0].description
        };
    } catch (error) {
        console.error('Failed to fetch weather:', error);
        return null;
    }
};
